import Constant from '@/common/constant/Constant';
import { I18n } from 'aws-amplify';
import Utils from '@/common/utils/utils';
import { filterExternalDeskProject } from '@/service/projectService';

const externalDeskProjectInitErrObj = {
    error: false,
    helperText: '',
}
const externalDeskProjectErrObj = {
    error: true,
    helperText: I18n.get('COMMSG001'),
}

/**
 * isShowExternalDeskRequestSystemForm (show/hide existed desk request/ invite guest desk)
 * @param {*} requestType
 * @param {*} formType
 * @param {*} formList
 * @param {*} projectInuseDetail
 * @returns
 */
export const isShowExternalDeskRequestSystemForm = (
    requestType,
    formType,
    formList,
    projectInuseDetail
) => {
    let status = false;
    let formId = '';

    let existDeskRequestForm = formList.find((form) => {
        return (
            form.definition === Constant.FORM_DEFINITION.SYSTEM &&
            form.type === formType &&
            form.usingProjects.includes(projectInuseDetail.id) &&
            requestType === Constant.EXTERNAL_REQUEST_TYPE.DESK_REQUEST
        );
    });
    if (!Utils.isEmptyObject(existDeskRequestForm)) {
        status = true;
        formId = existDeskRequestForm.id;
    }

    return { status, formId };
};

/**
 * searchExternalDeskProject
 * @param {*} argsAll
 * @param {*} keyword
 * @returns update setExternalDeskProject List
 */
export const searchExternalDeskProject = async (argsAll, keyword) => {
    try {
        // reset before search
        argsAll.setExternalDeskRequestProject({});
        argsAll.setOpenExternalDeskList(false);
        // argsAll.setExternalDeskRequestKeyword('');

        if (!keyword) {
            argsAll.setExternalDeskProjectList([]);
            argsAll.setExternalDeskProjectErr(externalDeskProjectErrObj);
            return;
        }
        keyword = keyword.trim();
        argsAll.setExternalDeskProjectErr(externalDeskProjectInitErrObj);

        argsAll.setIsLoading(true);

        let projectId = argsAll.projectInuseDetail.id;
        let corporationId = argsAll.projectInuseDetail.affiliationOrganization;
        let resProjectList = await filterExternalDeskProject(argsAll.API, projectId, corporationId, keyword)
        if (Utils.isEmptyArray(resProjectList)) {
            argsAll.setExternalDeskProjectList([]);
            argsAll.setExternalDeskProjectErr(externalDeskProjectErrObj);
            argsAll.setIsLoading(false);
            return;
        }

        let projectList = [];
        resProjectList.forEach((project) => {
            let corporationName = Utils.getTextByLanguage(
                Constant.LANGUAGE_TYPE.JP,
                project.corporationData.name
            );
            let projectName = Utils.getTextByLanguage(
                Constant.LANGUAGE_TYPE.JP,
                project.name
            );

            let projectOption = {
                value: project.id,
                title: `${projectName} (${corporationName})`,
                corporationId: project.corporationData.id,
            };
            projectList.push(projectOption); 
        });

        argsAll.setExternalDeskProjectList(projectList);
        argsAll.setIsLoading(false);
        argsAll.setOpenExternalDeskList(true);
    } catch (error) {
        console.log('searchExternalDeskProject ========', error);
        argsAll.setExternalDeskProjectList([]);
        argsAll.setExternalDeskProjectErr(externalDeskProjectErrObj);
        argsAll.setOpenExternalDeskList(false);
        argsAll.setIsLoading(false);
    }
};


/**
 * selectExternalDeskProject 
 * @param {*} argsAll 
 * @param {*} project 
 * @returns 
 */
export const selectExternalDeskProject = (argsAll, project) => {
    if (Utils.isEmptyObject(project) || !project.value) {
        return;
    }

    argsAll.setExternalDeskRequestProject(project);
    argsAll.setExternalDeskRequestKeyword(project.title);
    argsAll.setOpenExternalDeskList(false);
};

/**
 * handleOpenExternalDeskList
 * @param {*} argsAll 
 */
export const handleOpenExternalDeskList = (argsAll) => {
    argsAll.setOpenExternalDeskList(true);
};

export const onChangeExternalDeskInput = (e, argsAll) => {
    let keyword = e.target.value;

    if(argsAll?.externalDeskProjectErr?.error) {
        argsAll.setExternalDeskProjectErr({
            error: false,
            helperText: '',
        });
    } 
    argsAll.setIsEdited(true);
    argsAll.setExternalDeskRequestKeyword(keyword);
    argsAll.setOpenExternalDeskList(false);
    if (!keyword) {
        argsAll.setExternalDeskRequestProject({});
    }
};

/**
 * handleOnBlurExternalDeskRequest
 * @param {*} e 
 * @param {*} argsAll 
 */
export const handleOnBlurExternalDeskRequest = (e, argsAll) => {
    if(!argsAll?.externalDeskRequestKeyword) {
        argsAll.setExternalDeskProjectErr({
            error: true,
            helperText: I18n.get('COMMSG001'),
        });
    } else {
        argsAll.setExternalDeskProjectErr({
            error: false,
            helperText: '',
        });
    }
}

/**
 * onKeyPressSearchExternalDeskProject
 * @param {*} e 
 * @param {*} argsAll 
 * @param {*} keyword 
 */
export const onKeyPressSearchExternalDeskProject = (e, argsAll, keyword) => {
    if (e.key !== 'Enter') {
        return;
    }

    searchExternalDeskProject(argsAll, keyword);
}


/**
 * get option label display on input
 * @param {*} option 
 * @param {*} externalDeskRequestKeyword 
 * @returns 
 */
export const getOptionSearchLabel = (option, externalDeskRequestKeyword) => {
    let optionLabel = '';

    if (option && option.title) {
        return option.title;
    } else if (externalDeskRequestKeyword) {
        return externalDeskRequestKeyword;
    }
    return optionLabel;
}